module.exports = __webpack_public_path__ + "img/remove-discount.3693345b.svg";